import { createSelector } from 'reselect'
import { getTrackListItems } from '../../components/tracklist/trackListSelectors'

const getLocalState = state => state.pages.album || {}

export const getPochette = state => (getLocalState(state).image || {}).large
export const getTitle = state => getLocalState(state).title
export const getLabel = state => getLocalState(state).label
export const getArtist = state => getLocalState(state).artist || {}
export const getNbPistes = state => getLocalState(state).tracks_count
export const isHires = state => getLocalState(state).hires
export const getDuree = state => getLocalState(state).duration
export const isQobuzissime = state => getLocalState(state).isQobuzissime
export const getDescription = state => getLocalState(state).description
export const getOrderUrl = state => getLocalState(state).orderUrl
export const getGenre = state => getLocalState(state).genre
export const getReleasedAt = state => getLocalState(state).release_date_original
export const getMaximumBitDepth = state => getLocalState(state).maximum_bit_depth
export const getMaximumChannelCount = state => getLocalState(state).maximum_channel_count
export const getMaximumSamplingRate = state => getLocalState(state).maximum_sampling_rate
export const getMaximumTechnicalSpecification = state => getLocalState(state).maximum_technical_specifications

// On n'affiche l'artiste sur chaque track s'il est différent de l'artiste de l'album
export const shouldDisplayArtist = createSelector(
	getArtist,
	getTrackListItems,
	(artist, tracks) => {
		const tracksFiltered = tracks.filter(track => artist && track.performer && track.performer.id !== artist.id)

		return tracksFiltered.length > 0
	}
)



// WEBPACK FOOTER //
// ./src/pages/album/albumSelectors.js